import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MobileMenuComponent } from './mobile-menu-dropdown/mobile-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from 'app/auth/auth.service';
import { GtmService } from 'app/services/gtm.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { GlobalToasterService } from 'app/services/global-toaster.service';
import { GlobalToasterComponent } from '../global-toaster/global-toaster.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        CommonModule,
        RouterModule,
        MatMenuModule,
        TranslateModule,
        MobileMenuComponent,
        GlobalToasterComponent,
    ],
})
export class HeaderComponent {
    @Input() clicked: any;
    @Input() langSel: any;
    @Output() changeMegaMenuCondition: EventEmitter<any> = new EventEmitter();
    @Output() selectedLanguage: EventEmitter<any> = new EventEmitter();

    innerWidth: any;
    selecLang: string = 'en';
    isAuthenticated: boolean = false;
    isDropdownOpen: boolean | string = false;
    mobileMenuOpen: boolean = false;
    lang: any;

    headerDropdownValues = [
        {
            label: 'COMMON.FINANCING',
            subDropdownValues: [
                {
                    label: 'COMMON.BUSINESS_FINANCING_TITLE',
                    link: '/business-financing',
                },
                {
                    label: 'HOME.FINANCING_CALCULATOR',
                    link: '/financing-calculator',
                },
                {
                    label: 'DIGITAL_GUARANTEE',
                    link: '/digital-guarantee',
                },
                {
                    label: 'COMMON.GRANTS',
                    link: '/grants',
                },
            ],
        },
        {
            label: 'COMMON.BEYOND_FINANCING',
            subDropdownValues: [
                {
                    label: 'COMMON.INSURANCE',
                    link: '/insurance',
                },
                {
                    label: 'COMMON.DIGITAL_SERVICES',
                    link: '/digital-services',
                },
                {
                    label: 'COMMON.CGC_PROGRAMME',
                    link: '/cgc-developmental-programme',
                },
            ],
        },
        {
            label: 'COMMON.JC3_ESG_JUMPSTART',
        },
        {
            label: 'COMMON.WHATS_NEW',
        },
        {
            label: 'HOME.ABOUT',
            subDropdownValues: [
                {
                    label: 'ABOUT_IMSME',
                    link: '/about-us',
                },
                {
                    label: 'AWARDS.TITLE',
                    link: '/awards-achievements',
                },
                {
                    label: 'COMMON.PARTNERSHIP',
                    link: '/partnership',
                },
                // {
                //     label: 'COMMON.ESG',
                //     link: '/esg',
                // },
            ],
        },
    ];
    currentDropdownItems: any[] = [];

    financingDropDownValues = {
        label: 'COMMON.FINANCING',
        subDropdownValues: [
            {
                label: 'COMMON.BUSINESS_FINANCING_TITLE',
                href: '/business-financing',
            },
            {
                label: 'HOME.FINANCING_CALCULATOR',
                href: '/financing-calculator',
            },
            {
                label: 'DIGITAL_GUARANTEE',
                href: '/digital-guarantee',
            },
            {
                label: 'COMMON.GRANTS',
                href: '/grants',
            },
        ],
    };

    beyondFinancingDropDownValues = {
        label: 'COMMON.BEYOND_FINANCING',
        subDropdownValues: [
            {
                label: 'COMMON.INSURANCE',
                href: '/insurance',
            },
            {
                label: 'COMMON.DIGITAL_SERVICES',
                href: '/digital-services',
            },
            {
                label: 'COMMON.CGC_PROGRAMME',
                href: '/cgc-developmental-programme',
            },
        ],
    };

    whatsNewDropDownValues = {
        label: 'COMMON.WHATS_NEW',
        href: '/whats-new',
    };

    jc3EsgJumpstartDropDownValues = {
        label: 'COMMON.JC3_ESG_JUMPSTART',
        href: '/jc3-esg-jumpstart-for-smes',
    };

    aboutDropDownValues = {
        label: 'HOME.ABOUT',
        subDropdownValues: [
            {
                label: 'ABOUT_IMSME',
                href: '/about-us',
            },
            {
                label: 'AWARDS.TITLE',
                href: '/awards-achievements',
            },
            {
                label: 'COMMON.PARTNERSHIP',
                href: '/partnership',
            },
            // {
            //     label: 'COMMON.ESG',
            //     href: '/esg',
            // },
        ],
    };

    innerwidthBreakpoint = 1280;

    gtmTags: any = [];
    gtmTagsSocial: any = [];

    constructor(
        public router: Router,
        public authService: AuthService,
        private translate: TranslateService,
        private gtmService: GtmService,
        private route: ActivatedRoute,
        private gTag: GoogleAnalyticsService,
        public globalToasterSerive: GlobalToasterService
    ) {
        this.innerWidth = window.innerWidth;
        this.route.url.subscribe((segments) => {
            this.gtmTags = this.gtmService.getHeaderGtmTags(segments);
            this.gtmTagsSocial = this.gtmService.getFooterGtmTags(segments);
            // Inject GTM tags into headerDropdownValues
            if (this.gtmTags) {
                this.addTagsinHeader();
            }
        });
        let language = localStorage.getItem('language');
        this.selecLang = language || 'en';
        this.lang = language.toUpperCase();
        this.translate.use(language);
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    addTagsinHeader() {
        const gtmTagMap = {
            '/business-financing': 'Product',
            '/digital-guarantee': 'Digital_Guarantee',
            '/digital-services': 'Digital_Services',
            '/grants': 'Grants',
            '/insurance': 'Insurance',
            '/about-us': 'about_imSME',
            '/awards-achievements': 'Awards_Achievements',
            '/partnership': 'Partnership',
            '/esg': 'ESG',
            '/whats-new': 'whats_new',
            '/jc3-esg-jumpstart-for-smes': 'jc3',
            '/financing-calculator': 'Financing_Calculator',
            '/cgc-developmental-programme': 'CGC_developmental_programme',
        };

        const assignGtmTags = (
            items: any[],
            getPath: (item: any) => string
        ) => {
            items.forEach((item) => {
                const gtmKey = gtmTagMap[getPath(item)];
                const gtmData = this.gtmTags?.[gtmKey];
                if (gtmData) {
                    item.ga_event_id = gtmData.event;
                    item.ga_event_category = gtmData.event_category;
                    item.ga_event_label = gtmData.event_label;
                }
            });
        };

        // Apply to header dropdowns (nested structure)
        this.headerDropdownValues.forEach((dropdown) => {
            if (dropdown.subDropdownValues) {
                assignGtmTags(dropdown.subDropdownValues, (item) => item.link);
            } else {
                // For items like “What's New” without submenus
                assignGtmTags([dropdown], (item) =>
                    this.getLinkForLabel(item.label)
                );
            }
        });

        // Apply to other dropdowns
        const allDropdowns = [
            this.financingDropDownValues,
            this.beyondFinancingDropDownValues,
            this.aboutDropDownValues,
        ];

        allDropdowns.forEach((dropdown) => {
            assignGtmTags(dropdown.subDropdownValues, (item) => item.href);
        });
    }

    switchLanguage(language: string, fromHeader?: any) {
        this.selecLang = language || 'en';
        if (language) {
            this.gTag.event(
                this.gtmTags[language].event,
                this.gtmTags[language].event_category,
                this.gtmTags[language].event_label
            );

            this.lang = language.toUpperCase();
            localStorage.setItem('language', language);
            localStorage.setItem('switched_language', language); // for PAVE2277 and will be removed after refreshed
            let current_url = this.router.url;
            if (current_url.includes('language') && fromHeader) {
                let splitUrl = current_url.split('?');
                let newURL = splitUrl[0] + '?language=' + language;
                window.open(newURL, '_self');
                setTimeout(() => {
                    this.translate.use(language);
                    this.selectedLanguage.emit(language);
                }, 1000);
            } else {
                this.translate.use(language);
                this.selectedLanguage.emit(language);
            }
        }
    }

    toggleDropdown(e) {
        if (this.isDropdownOpen === e) {
            this.closeDropdown();
            return;
        }
        this.isDropdownOpen = e;
    }

    toggleMenu(label: string) {
        const selected = this.headerDropdownValues.find(
            (item) => item.label === label
        );
        this.currentDropdownItems = selected?.subDropdownValues || [];
    }

    getLinkForLabel(label: string): string {
        if (label === 'COMMON.WHATS_NEW') {
            return '/whats-new';
        }
        if (label === 'COMMON.JC3_ESG_JUMPSTART') {
            return '/jc3-esg-jumpstart-for-smes';
        }
        return '/'; // fallback
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    mobileMenuOpenToggle() {
        if (this.mobileMenuOpen) {
            this.mobileMenuOpen = false;
            return;
        }
        this.mobileMenuOpen = true;
    }

    toHomePage() {
        this.router.navigate(['']);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            (changes['clicked']?.currentValue &&
                changes['clicked']?.currentValue == true) ||
            (changes['clicked']?.previousValue == true &&
                changes['clicked']?.currentValue == false)
        ) {
            this.closeDropdown();
        }

        if (changes.langSel) {
            this.switchLanguage(changes['langSel'].currentValue);
        }
    }
}
